(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-custom-button-filters"] && !Shopify.designMode) return;
  try {
    
  (function (jQueryInstance) {
    if (!jQueryInstance) return;

    jQueryInstance(function ($) {
      var TABLET_BP = 799;
      var MOBILE_BP = 480;

      function getViewportKey() {
        var w = window.innerWidth;
        if (w <= MOBILE_BP) return 'mobile';
        if (w <= TABLET_BP) return 'tablet';
        return 'desktop';
      }

      function getSlidesToShow($slider, viewport) {
        if (viewport === 'mobile') {
          return parseFloat($slider.data('slides-mobile')) || 1.5;
        }
        if (viewport === 'tablet') {
          return parseInt($slider.data('slides-tablet'), 10) || 3;
        }
        return parseInt($slider.data('slides-desktop'), 10) || 5;
      }

      function getStaticCols(slideCount, slidesToShow) {
        var maxCols = slidesToShow % 1 !== 0 ? Math.floor(slidesToShow) : slidesToShow;
        return Math.min(slideCount, Math.max(1, maxCols));
      }

      function initCcCbFilterSliders() {
        if (!window.jQuery) return;

        $('.cc-slick-cb-filters').each(function () {
          var $slider = $(this);
          var $wrap = $slider.closest('.cc-upprtb-wrap');
          var layout = $slider.data('layout') || 'slider';
          var slideCount = parseInt($slider.data('slide-count'), 10) || $slider.children('.cc-button-item').length;
          var viewport = getViewportKey();
          var slidesToShow = getSlidesToShow($slider, viewport);
          var slidesDesktop = parseInt($slider.data('slides-desktop'), 10) || 5;
          var slidesTablet = parseInt($slider.data('slides-tablet'), 10) || 3;
          var slidesMobile = parseFloat($slider.data('slides-mobile')) || 1.5;
          var staticCols = getStaticCols(slideCount, slidesToShow);

          $wrap.addClass('cc-filters--processing').removeClass('cc-filters--ready');

          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
          }

          $slider.removeClass('cc-filters--static');
          $wrap.removeClass('cc-filters--no-drag');
          $slider[0].style.setProperty('--cb-grid-cols', String(staticCols));

          if (layout === 'grid') {
            $slider.addClass('cc-filters--static cc-filters--grid');
            $wrap.addClass('cc-filters--no-drag');
            $wrap.removeClass('cc-filters--processing').addClass('cc-filters--ready');
            return;
          }

          if (slideCount < slidesToShow) {
            $slider.addClass('cc-filters--static');
            $wrap.addClass('cc-filters--no-drag');
            $wrap.removeClass('cc-filters--processing').addClass('cc-filters--ready');
            return;
          }
          /* Make sure Slick is loaded */
          if (typeof $.fn.slick === 'undefined') {
            console.error('Slick Slider is not loaded.');
            return;
          }

          $slider.slick({
            slidesToShow: slidesDesktop,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            draggable: true,
            swipe: true,
            touchMove: true,
            responsive: [
              {
                breakpoint: MOBILE_BP,
                settings: {
                  slidesToShow: slidesMobile,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable: true,
                  swipe: true,
                  touchMove: true
                }
              },
              {
                breakpoint: TABLET_BP,
                settings: {
                  slidesToShow: slidesTablet,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable: true,
                  swipe: true,
                  touchMove: true
                }
              }
            ]
          });

          $wrap.removeClass('cc-filters--processing').addClass('cc-filters--ready');
        });
      }

      if (document.querySelector('.cc-custom-filter-wrapper')) {
        initCcCbFilterSliders();

        var resizeTimer;
        $(window).on('resize orientationchange', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(initCcCbFilterSliders, 150);
        });

        document.addEventListener('shopify:section:load', initCcCbFilterSliders);

        $(document).on('click', '.cc-filter-tab-btn', function (e) {
          e.preventDefault();

          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
          } else {
            $(this).addClass('active');
          }

          var currenttb = $(this).attr('data-tag');
          if ($('.filter-group__items').find('[data-tag="' + currenttb + '"]').length > 0) {
            $('.filter-group__items').find('[data-tag="' + currenttb + '"]').trigger('click');
          }
        });

        setInterval(function () {
          if ($('.csst_the-everydays')[0]) {
            $('.cc-cnn-the-everydays').addClass('active');
          } else {
            $('.cc-cnn-the-everydays').removeClass('active');
          }
          if ($('.csst_the-actives')[0]) {
            $('.cc-cnn-the-actives').addClass('active');
          } else {
            $('.cc-cnn-the-actives').removeClass('active');
          }
          if ($('.csst_the-comfies')[0]) {
            $('.cc-cnn-the-comfies').addClass('active');
          } else {
            $('.cc-cnn-the-comfies').removeClass('active');
          }
        }, 100);
      }
    });
  })(window.jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-custom-gallery-images"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGalleryCarousel(root) {
      var track = root.querySelector('.cc-gallery-carousel__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;

      var realCount = slides.length;
      var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 2500;

      for (var i = realCount - 1; i >= 0; i--) {
        var cloneBefore = slides[i].cloneNode(true);
        cloneBefore.setAttribute('aria-hidden', 'true');
        track.insertBefore(cloneBefore, track.firstChild);
      }
      for (var j = 0; j < realCount; j++) {
        var cloneAfter = slides[j].cloneNode(true);
        cloneAfter.setAttribute('aria-hidden', 'true');
        track.appendChild(cloneAfter);
      }

      var allSlides = Array.prototype.slice.call(track.children);
      var index = realCount;
      var autoplayTimer = null;
      var isDragging = false;
      var startX = 0;
      var currentX = 0;
      var dragOffset = 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function slideWidth() {
        return allSlides[0].getBoundingClientRect().width;
      }

      function peek() {
        var styles = window.getComputedStyle(root);
        return parseFloat(styles.getPropertyValue('--gallery-peek')) || 0;
      }

      function gap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap) || 0;
      }

     function setTransform(animate) {
      track.style.transition = animate
        ? 'transform 550ms cubic-bezier(0.22, 1, 0.36, 1)'
        : 'none';

      var offset =
        peek() -
        index * (slideWidth() + gap()) +
        dragOffset;

      track.style.transform =
        'translate3d(' + offset + 'px, 0, 0)';
    }

      function normalizeIndex() {
        if (index < realCount) {
          index += realCount;
          setTransform(false);
        } else if (index >= realCount * 2) {
          index -= realCount;
          setTransform(false);
        }
      }

      function goTo(nextIndex, animate) {
        index = nextIndex;
        setTransform(animate !== false);
      }

      function next() {
        goTo(index + 1, true);
      }

      function startAutoplay() {
        stopAutoplay();
        if (reducedMotion) return;
        autoplayTimer = window.setInterval(next, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      track.addEventListener('transitionend', function (event) {
        if (event.target !== track || event.propertyName !== 'transform') return;
        normalizeIndex();
      });

      function onPointerDown(clientX) {
        isDragging = true;
        startX = clientX;
        currentX = clientX;
        dragOffset = 0;
        root.classList.add('is-dragging');
        stopAutoplay();
        setTransform(false);
      }

      function onPointerMove(clientX) {
        if (!isDragging) return;
        currentX = clientX;
        dragOffset = currentX - startX;
        setTransform(false);
      }

      function onPointerUp() {
        if (!isDragging) return;

        isDragging = false;
        root.classList.remove('is-dragging');

        var threshold = Math.min(25, slideWidth() * 0.08);
        var direction = 0;

        if (dragOffset < -threshold) {
          direction = 1;
        } else if (dragOffset > threshold) {
          direction = -1;
        }

        // IMPORTANT: reset drag before animated transform
        dragOffset = 0;

        goTo(index + direction, true);

        startAutoplay();
      }

      root.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        event.preventDefault();
        onPointerDown(event.clientX);
      });
      window.addEventListener('mousemove', function (event) {
        onPointerMove(event.clientX);
      });
      window.addEventListener('mouseup', onPointerUp);

      root.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches[0]) return;
          onPointerDown(event.touches[0].clientX);
        },
        { passive: true }
      );
      root.addEventListener(
        'touchmove',
        function (event) {
          if (!event.touches[0]) return;
          onPointerMove(event.touches[0].clientX);
        },
        { passive: true }
      );
      root.addEventListener('touchend', onPointerUp);
      root.addEventListener('touchcancel', onPointerUp);

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', function () {
        if (!isDragging) startAutoplay();
      });
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      window.addEventListener('resize', function () {
        setTransform(false);
      });

      setTransform(false);
      startAutoplay();
    }

    function bootAll() {
      var carousels = document.querySelectorAll('.cc-gallery-carousel');
      carousels.forEach(function (carousel) {
        if (carousel.dataset.galleryReady === 'true') return;
        carousel.dataset.galleryReady = 'true';
        initGalleryCarousel(carousel);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.cc-gallery-carousel').forEach(function (carousel) {
        delete carousel.dataset.galleryReady;
      });
      bootAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();
})();
